import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import Pagination from "@mui/material/Pagination";
import { notification, Typography } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Loading from "../../components/Loading/LoadingEffect";
import { Link } from "react-router-dom";
import {
  AddImage,
  imageList,
} from "../../controllers/V1/products/productController";
import { ASSETS_BASE_URL } from "../../config/constants";
import { getPage } from "../../controllers/common";
import { InfoCircleOutlined, CheckCircleOutlined } from "@ant-design/icons";

const IMAGE_PAGE_LIMIT = 20;

const ImgUploader = ({ openUpload, toggleUploadOpen, setImgUrl }) => {
  const [images, setImages] = useState([]);
  const [imageListData, setImageListData] = useState([]);

  const handleCancel = () => {
    setCurrentPage(1);
    toggleUploadOpen();
  };

  const handleUploadImage = async (image) => {
    try {
      const formData = new FormData();
      formData.append("image", image);
      const params = formData;
      const res = await AddImage(params);

      if (res.status === true) {
        setImgUrl(res.result?.url);
        notification.open({
          message: "Success.",
          description: `Data successfully added/updated.`,
          placement: "topRight",
          icon: <CheckCircleOutlined style={{ color: "green" }} />,
          duration: 2,
        });
        handleCancel();
      } else {
        notification.open({
          message: "Error.",
          description: `${res.message}`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      notification.open({
        message: "Validation Error.",
        description: `Please check the form and try again.`,
        placement: "topRight",
        icon: <InfoCircleOutlined style={{ color: "red" }} />,
        duration: 2,
      });
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const newImage = {
        url: URL.createObjectURL(file),
        file,
      };
      setImages([...images, newImage]);
      handleUploadImage(file);
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  // const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);

  const getImageList = async () => {
    try {
      setIsLoading(true);
      const pageSkip = (currentPage - 1) * IMAGE_PAGE_LIMIT;

      const options = {
        type: "",
        select: {},
        sort: { status: 1, _id: -1 },
        skip: pageSkip,
        limit: IMAGE_PAGE_LIMIT,
      };
      const listData = await imageList(options);
      if (listData.status === true) {
        setImageListData(listData?.result?.length > 0 ? listData.result : []);
        setTotalCount(listData?.count || 0);
        setTotalPages(getPage(listData?.count || 0, IMAGE_PAGE_LIMIT) || 1);
      } else {
        setImageListData([]);
        setTotalCount(0);
        setTotalPages(1);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const handlePageChange = (_, newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {
    if (openUpload) {
      getImageList();
    }
  }, [openUpload, currentPage]);
  const [selectedImage, setSelectedImage] = useState(null);
  const handleSelect = (item) => {
    if (selectedImage?._id === item._id) {
      // Deselect if the same image is selected
      setSelectedImage(null);
    } else {
      // Select the clicked image
      setSelectedImage(item);
    }
  };
  const sendDataToParent = (data) => {
    if (data?._id) {
      setImgUrl(data?.url || "");
    } else {
      setImgUrl("");
    }
    setCurrentPage(1);
    toggleUploadOpen();
  };

  return (
    <Dialog
      open={openUpload}
      onClose={handleCancel}
      fullWidth={true}
      maxWidth={"md"}
      PaperProps={{
        className: "myDialogPopUp",
      }}
    >
      <div className="myDrawer">
        <div className="inventory_popup_title">
          <Typography
            variant="h5"
            component="div"
            gutterBottom
            className="inventory_popup_title_heading"
          >
            Upload/Select Images
          </Typography>
          <Link
            to={false}
            style={{ position: "absolute", right: 8, top: 8, color: "#dd5151" }}
            onClick={handleCancel}
          >
            <FontAwesomeIcon icon={faTimesCircle} />
          </Link>
        </div>

        <Typography
          variant="body1"
          component="div"
          className="my_delete_popup_paragraph"
        >
          <div className="container-fluid">
            <div className="categories_open_popup_main_contnet">
              <div className="image-grid">
                <div className="upload-block">
                  <label htmlFor="file_upload" className="upload-label">
                    <FontAwesomeIcon icon={faPlus} className="upload-icon" />
                    <input
                      type="file"
                      id="file_upload"
                      className="file-input"
                      accept="image/*"
                      onChange={handleFileUpload}
                    />
                  </label>
                </div>
                

                {imageListData &&
                  [...imageListData]
                    .map((item) => (
                      <div
                        key={item._id}
                        className={`upload-block ${
                          selectedImage?._id === item._id ? "active" : ""
                        }`}
                        onClick={() => {
                          handleSelect(item);
                        }}
                        onDoubleClick={() => sendDataToParent(item)}
                      >
                        <img src={ASSETS_BASE_URL + item.url} alt={item.name} />
                      </div>
                    ))}
              </div>
              {totalCount > IMAGE_PAGE_LIMIT && (
                <div className="table_pagination_sales_order">
                  <p>{`${(currentPage - 1) * IMAGE_PAGE_LIMIT + 1} - ${Math.min(currentPage * IMAGE_PAGE_LIMIT, totalCount)} of ${totalCount}`}</p>
                  <Pagination
                    count={totalPages}
                    page={currentPage}
                    onChange={handlePageChange}
                  />
                </div>
              )}
            </div>
            <div className="row">
              <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                <div className="verndor_dashboard_add_edit_button">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={() => {
                      sendDataToParent(selectedImage);
                    }}
                  >
                    Proceed
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Typography>
        {/* {error && <div style={{ color: "red" }}>{error}</div>} */}
      </div>

      <Loading isLoading={isLoading} text={`Preparing download...`} />
    </Dialog>
  );
};

export default ImgUploader;
